export default __webpack_public_path__ + "static/media/mobileWef2Full.48ee81bb.png";